/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isFunction } from "@adapptio/lib-shared";
import { useEventListener } from "@adapptio/lib-editor-ui";

/**
 * Sets up global body click event listener when active
 * Usable for closing floating menus and elements.
 *
 * @param onClick On click handler
 * @param active If to listen to clicks
 */
export function useBodyClick(onClick: (ev: globalThis.MouseEvent) => void, active: boolean): void {
	useEventListener(
		document?.body,
		"click",
		(...args) => {
			if (active && isFunction(onClick)) {
				onClick(...args);
			}
		},
		undefined,
		active
	);
}
